































































import {
    myVue
} from "@/components/class/myVue";
import {
    Component
} from 'vue-property-decorator';
import * as utils from "@/components/util/utils";

@Component
export default class HelloWorld extends myVue {
    get srcList() {
        let list = []
        for (let i = 0; i < this.current.value.length; i++) {
            list.push(this.current.value[i].url)
        }
        return list
    }

    ShowImg(file: any) {
        this.current.file_ol = file
        this.current.img_show = true;
    }

    Download(file: any) {
        utils.myDownload({
            fileName: file.name,
            apiName_download: file.url
        })
    }

    handlePictureCardPreview(fileObj: any, ratio: any, callback: any) {
        const _that: any = this
        const file: any = fileObj
        const _file: any = file
        const isLt10M = file.size / 1024 / 1024 < 20
        if (!isLt10M) {
            utils.myMessage({
                message: "上传图片大小不能超过 20M!"
            })
            return false
        } else {
            _that.dialogImageUrl = URL.createObjectURL(file.raw)
            utils.compress(file.raw, function (val: any) {
                let i = _that.$refs.uploadxls.uploadFiles.length
                var file = _that.blobToFile(val, _that.$refs.uploadxls.uploadFiles[i - 1].name);
                file.lastModified = _file.lastModified
                file.percentage = _file.percentage
                file.status = _file.status
                file.uid = _file.uid
                _that.$refs.uploadxls.uploadFiles[i - 1].raw = file
                _that.$refs.uploadxls.uploadFiles[i - 1].size = file.size
                _that.$refs.uploadxls.submit()
            }, callback)
        }
    }
    compress(file: any, fileList: any) {
        this.current.hideUpload = fileList.length >= this.current.limit;
    }
    beforeAvatarUpload(file: any) {
        this.current.loading = true
    }
    su(response: any, file: any, fileList: any) {
        this.current.loading = false
        this.current.hideUpload = fileList.length >= this.current.limit;
        let newValue: any[] = []
        if (utils.isNull(fileList)) {
            this.current.value = newValue
            return
        }
        for (let l = 0; l < fileList.length; l++) {
            if (fileList[l].response && fileList[l].response.list && fileList[l].response.list[0].url) {
                newValue.push({
                    "url": "/api/" + fileList[l].response.list[0].url,
                    "name": fileList[l].response.list[0].name
                })
            } else {
                newValue.push(fileList[l])
            }
        }
        this.current.value = newValue
    }

    deleteImg(file: any) {
        let newValue: any[] = []
        for (let l = 0; l < this.current.value.length; l++) {
            if (file.name != this.current.value[l].name) {
                newValue.push(this.current.value[l])
            }
        }
        this.current.value = newValue
        this.current.hideUpload = newValue.length >= this.current.limit;
    }

    editImg(file: any) {
        this.current.text_show = true;
        this.current.file_ol = file;
    }
}
